import React from 'react';

import styled from 'styled-components';
import { centsToDollarsAndCentsArray } from 'utils';

import TimCardIcon from 'components/icons/tims-logo';
import LoadingAnimation from 'components/loading-animation';

interface IColorable {
  color?: 'inverted';
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
`;

const IconContainer = styled.div`
  width: 300px;
`;

const CardNumber = styled.span<IColorable>`
  color: ${props => (props.color === 'inverted' ? Styles.color.white : Styles.color.black)};
  margin: 0;
`;

const Balance = styled.span<IColorable>`
  color: ${props => (props.color === 'inverted' ? Styles.color.white : Styles.color.black)};
  display: flex;
  margin-top: 1rem;
`;

const CurrencySymbol = styled.span<IColorable>`
  color: ${props => (props.color === 'inverted' ? Styles.color.white : Styles.color.black)};
  font-size: 1.625rem;
  font-weight: ${Styles.fontWeight.heavy};
  opacity: 0.5;
  margin-right: 0.25rem;
  position: relative;
`;

const BalanceDollars = styled.span`
  font-size: 4.6875rem;
  line-height: 1;
  letter-spacing: -2px;
  margin-right: 0.2rem;
  position: relative;
`;

const BalanceCents = styled.span`
  font-size: 1.625rem;
  position: relative;
`;

interface IGiftCardInfo {
  isLoading: boolean;
  cardNumberFormatted: string;
  totalCents: number;
  color?: 'inverted';
}

export const GiftCardInfo = ({
  isLoading,
  totalCents,
  color,
  cardNumberFormatted,
}: IGiftCardInfo) => {
  const [dollars, cents] = centsToDollarsAndCentsArray(totalCents);
  let primaryFill;
  let secondaryFill;
  let animationFill = Styles.color.primary;
  if (color === 'inverted') {
    primaryFill = Styles.color.white;
    secondaryFill = Styles.color.white;
    animationFill = Styles.color.white;
  }
  return (
    <Container data-testid="gift-card-info">
      {isLoading ? (
        <LoadingAnimation fillColor={animationFill} />
      ) : (
        <>
          <IconContainer>
            <TimCardIcon
              viewBox="-17.5 0 60 10"
              primaryFill={primaryFill}
              secondaryFill={secondaryFill}
            />
          </IconContainer>
          <CardNumber color={color}>{cardNumberFormatted}</CardNumber>
          <Balance color={color}>
            <CurrencySymbol color={color}>$</CurrencySymbol>
            <BalanceDollars>{dollars}</BalanceDollars>
            <BalanceCents>{cents}</BalanceCents>
          </Balance>
        </>
      )}
    </Container>
  );
};

export default GiftCardInfo;
